import { RouteObject } from "react-router-dom";
import {
  COMPANY_DOCUMENTS_PATH,
  CompanyDocumentsPage,
} from "./pages/company-documents";
import { COMPANY_DOCUMENTS_EDIT_PATH } from "./pages/company-documents-edit";
import CompanyDocumentsEdit from "./pages/company-documents-edit/company-documents-edit";

export const companyDocumentsRoutes: RouteObject[] = [
  {
    path: COMPANY_DOCUMENTS_PATH,
    element: <CompanyDocumentsPage />,
  },
  {
    path: COMPANY_DOCUMENTS_EDIT_PATH,
    element: <CompanyDocumentsEdit />,
  },
];
